import React from "react";
import { BrowserRouter as Router, Route, Routes, useNavigate, useParams } from "react-router-dom";
import Login from "./pages/Login/Login";
import Forms from "./pages/Forms";
import Dashboard from "./pages/Dashboard/Dashboard";
import Profile from "./pages/ProfilePage";
import MultiUser from "./pages/MultiUser";
import Appointments from "./pages/Appointments";
import Header from "./components/Header/Header";
import NavBar from "./components/headerMenu/NavBar";
import Payment from "./pages/PaymentHistory";

const ProfileWrapper = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  return <Profile navigate={navigate} clientId={id} />;
};

export const AppRouter = () => {
  return (
    <Router>
      <div className="main-wrapper" style={{backgroundColor: "#e5e8ef"}}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<MultiUser />} />
          <Route
            path="/:id"
            element={
              <>
                <Header />
                <NavBar />
                <ProfileWrapper />
              </>
            }
          />
          <Route
            path="forms/:id"
            element={
              <>
                <Header />
                <NavBar />
                <Forms />
              </>
            }
          />
          <Route
            path="appointments/:id"
            element={
              <>
                <Header />
                <NavBar />
                <Appointments />
              </>
            }
          />
          <Route
            path="payment/:id"
            element={
              <>
                <Header />
                <NavBar />
                <Payment />
              </>
            }
          />
        </Routes>
      </div>
    </Router>
  );
};
